import { Component, OnInit, inject } from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  RunTransition,
  RunTransitionWithDialog,
  WorkflowService,
} from '../../services/workflow/workflow.service';
import { PayeePopupComponent } from '../../payee-popup/payee-popup.component';
import { PayeeFormFieldComponent } from '../../payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';
import { PayeeIconComponent } from '../../payee-icon/payee-icon.component';

type DialogData = {
  transition_label: string;
};

@Component({
  selector: 'app-case-assigned-to-bailiff-dialog',
  templateUrl: './case-assigned-to-bailiff-dialog.component.html',
  styleUrls: ['./case-assigned-to-bailiff-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeFormFieldComponent,
    PayeeButtonComponent,
    PayeeIconComponent,
  ],
})
export class CaseAssignedToBailiffDialogComponent implements OnInit {
  private fb = inject(FormBuilder);
  private data = inject<RunTransitionWithDialog>(MAT_DIALOG_DATA);
  private dialogRef =
    inject<MatDialogRef<CaseAssignedToBailiffDialogComponent>>(MatDialogRef);
  private workflowService = inject(WorkflowService);

  loading = false;
  dialogData?: DialogData;

  readonly form = this.fb.group({
    bailiff_information: this.fb.control('', {
      validators: [Validators.required, Validators.pattern(/^\d{4}$/)],
      nonNullable: true,
    }),
  });

  get bailiff_information() {
    return this.form.controls.bailiff_information;
  }

  async ngOnInit() {
    this.dialogData = (await this.workflowService.getDialogData({
      caseId: this.data.caseId,
      transitionId: this.data.transitionId,
    })) as DialogData;
  }

  readonly onCancel = () => {
    this.dialogRef.close();
  };

  async submit(): Promise<void> {
    if (this.form.invalid) {
      this.bailiff_information.markAsDirty();
      return;
    }

    const { bailiff_information } = this.form.getRawValue();

    const closeValue: RunTransition = {
      caseId: this.data.caseId,
      transitionId: this.data.transitionId,
      params: {
        ...(this.data.extraParams ?? {}),
        bailiff_information,
      },
    };

    this.loading = true;
    try {
      await this.workflowService.runTransition(closeValue);
      this.dialogRef.close(closeValue);
    } catch (error) {
      this.workflowService.showTransitionError(error);
    } finally {
      this.loading = false;
    }
  }
}
